export default __webpack_public_path__ + "static/media/IMG_3551.0e813276.jpg";